module.exports = __webpack_public_path__ + "img/47b77b2.jpg";